module.exports = __webpack_public_path__ + "static/media/logo-regione.668106d3.svg";